import { jsx as _jsx } from "react/jsx-runtime";
import { GridCol, GridRow, getTestId } from '@airtel/air-design-system';
import SingleDetailsField from '../single-task-field/SingleTaskDetailsField';
export var SingleTaskCardField = props => {
  var _a, _b;
  var singleTaskCardDetails = props.singleTaskCardDetails,
    singleCardStyle = props.singleCardStyle;
  var numberColumns = (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.numberOfColumns) > 3 ? 3 : (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.numberOfColumns) < 1 ? 1 : (_a = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.numberOfColumns) !== null && _a !== void 0 ? _a : 2;
  var renderSingleDetailCard = (innerItem, index) => {
    return _jsx(SingleDetailsField, Object.assign({}, props, {
      index: index,
      innerItem: innerItem
    }, getTestId(props === null || props === void 0 ? void 0 : props.testID, index.toString())));
  };
  return ((_b = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.detailsData) === null || _b === void 0 ? void 0 : _b.length) > 0 && _jsx(GridRow, Object.assign({
    style: [{
      marginTop: 16
    }, singleCardStyle]
  }, {
    children: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.detailsData.map((detailsData, index) => {
      return _jsx(GridCol, Object.assign({
        noTopGutter: true,
        breakpoints: Object.assign({
          xs: 12 / numberColumns
        }, detailsData.detailsBreakpoints)
      }, {
        children: renderSingleDetailCard(detailsData, index)
      }), index);
    })
  }));
};
export default SingleTaskCardField;